import amplitude from "amplitude-js";
import { amplitudeKey, enableAnalytics } from "config";
import { logGAEvent } from "./googleanalytics.service";
import { postDataToEventHub } from "./eventhub.service";

if (enableAnalytics) {
  amplitude.getInstance().init(amplitudeKey);
}

function initAmplitude(userId) {
  if (!enableAnalytics) return;
  amplitude.getInstance().setUserId(userId);
}

function logEvent(eventName, eventProperties) {
  if (!enableAnalytics) return;
  postDataToEventHub(eventName, eventProperties);
  amplitude.getInstance().logEvent(eventName, eventProperties);
  logGAEvent(eventName, eventProperties);
}

export { initAmplitude, logEvent };
